import Vue from 'vue';

export default {
    getEmpleados(parametros){
        return Vue.axios.get("empleados/find", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getEmpleado(id){
        return Vue.axios.get("empleados/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    updateEmpleado(parametros){
        return Vue.axios.post("empleados/update-empleado", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    deleteEmpleado(id){
        return Vue.axios.delete("empleados/"+ id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    eliminarEmpleado(parametros){
        return Vue.axios.post("empleados/eliminar", parametros ).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    },
    reingresoEmpleado(parametros){
        return Vue.axios.post("empleados/reingreso", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    addEmpleado(parametros){
        return Vue.axios.post("empleados", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    importarEmpleados(parametros){
        return Vue.axios.post("empleados/importar", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getDashboard(parametros){
        return Vue.axios.get("empleados/dashboard", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    asignacionEmpleado(parametros){
        return Vue.axios.post("empleados/asignacion", parametros ).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    },
    cumpleaniosEmpleado(parametros){
        return Vue.axios.get("empleados/cumpleanios", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getKardexCollections(parametros){
        return Vue.axios.post("empleados/load-kardex-collections", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getHistorico(parametros){
        return Vue.axios.get("historico_empleado/find", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getDashboardNominas(parametros){
        return Vue.axios.post("dashboard/nominas", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    addBeneficiario(parametros){
        return Vue.axios.post("beneficiarios", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    updateBeneficiario(parametros){
        return Vue.axios.put("beneficiarios", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    deleteBeneficiario(id){
        return Vue.axios.delete("beneficiarios/"+ id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    historicoVacaciones(parametros){
        return Vue.axios.post("reportes/historico-vacaciones", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },

    // INFONAVIT
    historicoInfonavitFind(parametros){
        return Vue.axios.get("empleados/historico_infonavit/find", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    historicoInfonavitAdd(parametros){
        return Vue.axios.post("empleados/historico_infonavit", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    historicoInfonavitUpdate(parametros){
        return Vue.axios.put("empleados/historico_infonavit", parametros ).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    historicoInfonavitDelete(id){
        return Vue.axios.delete("empleados/historico_infonavit/"+ id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },

    // FONACOT - Créditos
    historicoFonacotFind(parametros){
        return Vue.axios.get("empleados/historico_fonacot/find", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    historicoFonacotAdd(parametros){
        return Vue.axios.post("empleados/historico_fonacot", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    historicoFonacotUpdate(parametros){
        return Vue.axios.put("empleados/historico_fonacot", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    historicoFonacotDelete(id){
        return Vue.axios.delete("empleados/historico_fonacot/"+ id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },

    // FONACOT - Movimientos
    fonacotMovimientoFind(creditoId){
        return Vue.axios.get("empleados/historico_fonacot/movimiento/find/"+ creditoId).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    fonacotMovimientoAdd(parametros){
        return Vue.axios.post("empleados/historico_fonacot/movimiento", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    fonacotMovimientoUpdate(parametros){
        return Vue.axios.put("empleados/historico_fonacot/movimiento", parametros).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    }

}